// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"78437d80","453":"7d7e42c7","732":"bae25164","977":"684ad850"}[chunkId] + ".chunk.js";
};